import { Dispatch, SetStateAction } from 'react'
import Icon from '../Icon'

interface SearchProps {
	placeholder: string
	value: string
	setSelectedField: Dispatch<SetStateAction<string>>
}

export default function Search({
	placeholder,
	value,
	setSelectedField,
}: SearchProps) {
	return (
		<div className='relative w-full'>
			<div className='absolute inset-y-0 start-0 flex items-center ps-5 pointer-events-none'>
				<Icon
					name='search'
					fill='#8493ac'
					stroke='#8493ac'
					width='14px'
					height='14px'
				/>
			</div>
			<input
				type='text'
				onChange={(value) => setSelectedField(value.target.value)}
				value={value}
				className='bg-transparent rounded-full border dark:border-white/20 text-sm block w-full ps-12 p-2 placeholder:text-sm placeholder:text-[#000000]/80 dark:placeholder:text-white dark:focus:border-white/40 focus:border-gray-500/40 text-[#000000] dark:text-white outline-none transition-all duration-400 ease-in-out disabled:pointer-events-none appearance-none disabled:bg-none disabled:shadow-none'
				placeholder={placeholder}
			/>
		</div>
	)
}
